// extracted by mini-css-extract-plugin
export default {"precision":"DcTiA","precision__checkbox":"geFoi","precision__toggleButton":"nnLYF","precision__list":"i4woY","precision__toggleButtonText":"KXlNs","precision__itemButton":"AEUuq"};